/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNurse = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M5.296 2.74A9.501 9.501 0 0 1 12 0a9.501 9.501 0 0 1 6.704 2.74l.543.539-2.253 3.975a5 5 0 0 1-9.936.509l-2.279-4.51zm1.941.942L8.24 5.666A9.57 9.57 0 0 1 12 4.902c1.283 0 2.509.252 3.626.708l1.107-1.952A7.516 7.516 0 0 0 12 2a7.515 7.515 0 0 0-4.763 1.682zM12 6.902a7.571 7.571 0 0 0-2.959.597 3 3 0 0 0 5.918 0A7.571 7.571 0 0 0 12 6.902zM6.502 17.52C5.48 18.385 5 19.585 5 21v1H3v-1c0-1.9.664-3.7 2.212-5.008C6.739 14.703 9 14 12 14c3 0 5.261.704 6.788 1.992C20.336 17.3 21 19.1 21 21v1h-2v-1c0-1.417-.48-2.616-1.502-3.48C16.453 16.64 14.715 16 12 16c-2.715 0-4.453.638-5.498 1.52z" />
        <path d="M11.1 17v1.6H9.5v1.8h1.6V22h1.8v-1.6h1.6v-1.8h-1.6V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgNurse as Nurse };
